// extracted by mini-css-extract-plugin
export default {"title_box":"germanyAppComponent_title_box__B7OdB","img_box":"germanyAppComponent_img_box__YnPph","line":"germanyAppComponent_line__c6B1g","app":"germanyAppComponent_app__soHNz"};